import { getConfig } from '@edx/frontend-platform';
import { Icon } from '@edx/paragon';
import { useIntl } from '@edx/frontend-platform/i18n';
import { Login } from '@edx/paragon/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import messages from './messages';
import PropTypes from 'prop-types';

import { LOGIN_PAGE, SUPPORTED_ICON_CLASSES } from '../data/constants';
import { isExternalLink } from '../data/utils/dataUtils';
import { getProviderObjLabel } from './../register/data/utils';

const SocialAuthProviders = (props) => {
  const { referrer, socialAuthProviders } = props;
  const { formatMessage } = useIntl();

  function handleSubmit(e) {
    e.preventDefault();
    const url = e.currentTarget.dataset.providerUrl;
    const fullUrl = getConfig().LMS_BASE_URL + url;

    // Check if inside an iframe
    if (window.top !== window.self) {
      // In an iframe – open in a new tab
      window.open(fullUrl, '_blank');
    } else {
      // Not in an iframe – redirect in same tab
      window.location.href = fullUrl;
    }
  }

  const socialAuth = socialAuthProviders.map((provider) => {
    const providerLabel = getProviderObjLabel(provider, messages, formatMessage);

    return (
      <button
        id={provider.id}
        key={provider.id}
        type="button"
        className="third-party-provider flex-center-column mb-2 btn-onboarding"
        style={props.style}
        data-provider-url={
          referrer === LOGIN_PAGE ? provider.loginUrl : provider.registerUrl
        }
        onClick={handleSubmit}
        data-gtm={`third-party-provider-${provider.id}`}
      >
        <div className="d-flex justify-content-center align-items-center flex-row sso-provider-items" data-gtm={`third-party-provider-${provider.id}`}>
          {provider.iconImage ? (
            <img
              className="icon-image"
              src={`${
                !isExternalLink(provider.iconImage)
                  ? getConfig().LMS_BASE_URL + provider.iconImage
                  : provider.iconImage
              }`}
              alt={`icon ${provider.name}`}
              data-gtm={`third-party-provider-${provider.id}`}
            />
          ) : (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              {SUPPORTED_ICON_CLASSES.includes(provider.iconClass) ? (
                <FontAwesomeIcon icon={["fab", provider.iconClass]} />
              ) : (
                <Icon className="h-75" src={Login} />
              )}
            </>
          )}
          <p className="w-100 sso-provider-name mr-2" data-gtm={`third-party-provider-${provider.id}`}>
            {formatMessage(messages['sso.sign.in.with'], {
              providerName: providerLabel,
            })}
          </p>
        </div>
      </button>
    );
  });

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{socialAuth}</>;
};

SocialAuthProviders.defaultProps = {
  referrer: LOGIN_PAGE,
  socialAuthProviders: [],
};

SocialAuthProviders.propTypes = {
  referrer: PropTypes.string,
  socialAuthProviders: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    iconClass: PropTypes.string,
    iconImage: PropTypes.string,
    loginUrl: PropTypes.string,
    registerUrl: PropTypes.string,
    skipRegistrationForm: PropTypes.bool,
  })),
  // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
  style: PropTypes.object,
};

SocialAuthProviders.defaultProps = {
  style: {},
};

export default SocialAuthProviders;
